import { createBrowserRouter, Navigate, Outlet } from 'react-router';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { AppLayout } from './app-layout';
import { RouteError } from './route-error';
import { LoginPage } from '@/features/auth/login-page';
import { RegisterPage } from '@/features/auth/register-page';
import { ForgotPasswordPage } from '@/features/auth/forgot-page';
import { ResetPasswordPage } from '@/features/auth/reset-page';
import { AcceptInvitePage } from '@/features/auth/accept-invite-page';
import * as dashboard from '@/features/dashboard/routes';
import * as agenda from '@/features/agenda/routes';
import * as customers from '@/features/customers/routes';
import * as finance from '@/features/finance/routes';
import * as catalog from '@/features/catalog/routes';
import * as settings from '@/features/settings/routes';
import * as site from '@/features/site/routes';
import * as ai from '@/features/ai/routes';
import * as marketing from '@/features/marketing/routes';
import * as legal from '@/features/legal/routes';
import { platformRoutes } from '@/features/platform/routes';

function Root() {
  return (
    <NuqsAdapter>
      <Outlet />
    </NuqsAdapter>
  );
}

export const router = createBrowserRouter([
  {
    element: <Root />,
    errorElement: <RouteError />,
    children: [
      ...marketing.publicRoutes,
      ...site.publicRoutes,
      ...legal.publicRoutes,
      { path: 'entrar', element: <LoginPage /> },
      { path: 'cadastrar', element: <RegisterPage /> },
      { path: 'esqueci-senha', element: <ForgotPasswordPage /> },
      { path: 'redefinir-senha', element: <ResetPasswordPage /> },
      { path: 'convite', element: <AcceptInvitePage /> },
      ...platformRoutes,
      {
        path: 'app',
        element: <AppLayout />,
        errorElement: <RouteError />,
        children: [
          ...dashboard.appRoutes,
          ...agenda.appRoutes,
          ...customers.appRoutes,
          ...finance.appRoutes,
          ...catalog.appRoutes,
          ...settings.appRoutes,
          ...site.appRoutes,
          ...ai.appRoutes,
        ],
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
